// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BookRouteImport } from './routes/book'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as CaseStudyRouteImport } from './routes/case-study'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProcessRouteImport } from './routes/process'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedBriefsRouteImport } from './routes/_authenticated/briefs'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as GuidesHoustonWebsiteCostRouteImport } from './routes/guides.houston-website-cost'
import { Route as GuidesSquarespaceVsCustomWebsiteRouteImport } from './routes/guides.squarespace-vs-custom-website'
import { Route as GuidesWebsiteAuditChecklistRouteImport } from './routes/guides.website-audit-checklist'
import { Route as PortalLoginRouteImport } from './routes/portal.login'
import { Route as ProposalTokenRouteImport } from './routes/proposal.$token'
import { Route as RedesignIndexRouteImport } from './routes/redesign.index'
import { Route as RedesignTokenRouteImport } from './routes/redesign.$token'
import { Route as SiteReportTokenRouteImport } from './routes/site-report.$token'
import { Route as StudioPrivacyRouteImport } from './routes/studio_.privacy'
import { Route as StudioTermsRouteImport } from './routes/studio_.terms'
import { Route as WorkIndexRouteImport } from './routes/work.index'
import { Route as WorkSlugRouteImport } from './routes/work.$slug'
import { Route as AuthenticatedProjectsProjectIdRouteImport } from './routes/_authenticated/projects.$projectId'
import { Route as AuthenticatedProposalsProposalIdRouteImport } from './routes/_authenticated/proposals.$proposalId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuditRoute = AuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const BriefRoute = BriefRouteImport.update({
            id: '/brief',path: '/brief',getParentRoute: () => rootRouteImport
          })
const CaseStudyRoute = CaseStudyRouteImport.update({
            id: '/case-study',path: '/case-study',getParentRoute: () => rootRouteImport
          })
const ClientsRoute = ClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => rootRouteImport
          })
const ConnectRoute = ConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProcessRoute = ProcessRouteImport.update({
            id: '/process',path: '/process',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const StudioRoute = StudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBriefsRoute = AuthenticatedBriefsRouteImport.update({
            id: '/briefs',path: '/briefs',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRouteRoute
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const GuidesHoustonWebsiteCostRoute = GuidesHoustonWebsiteCostRouteImport.update({
            id: '/guides/houston-website-cost',path: '/guides/houston-website-cost',getParentRoute: () => rootRouteImport
          })
const GuidesSquarespaceVsCustomWebsiteRoute = GuidesSquarespaceVsCustomWebsiteRouteImport.update({
            id: '/guides/squarespace-vs-custom-website',path: '/guides/squarespace-vs-custom-website',getParentRoute: () => rootRouteImport
          })
const GuidesWebsiteAuditChecklistRoute = GuidesWebsiteAuditChecklistRouteImport.update({
            id: '/guides/website-audit-checklist',path: '/guides/website-audit-checklist',getParentRoute: () => rootRouteImport
          })
const PortalLoginRoute = PortalLoginRouteImport.update({
            id: '/portal/login',path: '/portal/login',getParentRoute: () => rootRouteImport
          })
const ProposalTokenRoute = ProposalTokenRouteImport.update({
            id: '/proposal/$token',path: '/proposal/$token',getParentRoute: () => rootRouteImport
          })
const RedesignIndexRoute = RedesignIndexRouteImport.update({
            id: '/redesign/',path: '/redesign/',getParentRoute: () => rootRouteImport
          })
const RedesignTokenRoute = RedesignTokenRouteImport.update({
            id: '/redesign/$token',path: '/redesign/$token',getParentRoute: () => rootRouteImport
          })
const SiteReportTokenRoute = SiteReportTokenRouteImport.update({
            id: '/site-report/$token',path: '/site-report/$token',getParentRoute: () => rootRouteImport
          })
const StudioPrivacyRoute = StudioPrivacyRouteImport.update({
            id: '/studio_/privacy',path: '/studio/privacy',getParentRoute: () => rootRouteImport
          })
const StudioTermsRoute = StudioTermsRouteImport.update({
            id: '/studio_/terms',path: '/studio/terms',getParentRoute: () => rootRouteImport
          })
const WorkIndexRoute = WorkIndexRouteImport.update({
            id: '/work/',path: '/work/',getParentRoute: () => rootRouteImport
          })
const WorkSlugRoute = WorkSlugRouteImport.update({
            id: '/work/$slug',path: '/work/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedProjectsProjectIdRoute = AuthenticatedProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProposalsProposalIdRoute = AuthenticatedProposalsProposalIdRouteImport.update({
            id: '/proposals/$proposalId',path: '/proposals/$proposalId',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedBriefsRoute: AuthenticatedBriefsRoute,AuthenticatedPortalRoute: AuthenticatedPortalRoute,AuthenticatedProjectsProjectIdRoute: AuthenticatedProjectsProjectIdRoute,AuthenticatedProposalsProposalIdRoute: AuthenticatedProposalsProposalIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuditRoute: AuditRoute,AuthRoute: AuthRoute,BookRoute: BookRoute,BriefRoute: BriefRoute,CaseStudyRoute: CaseStudyRoute,ClientsRoute: ClientsRoute,ConnectRoute: ConnectRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProcessRoute: ProcessRoute,ServicesRoute: ServicesRoute,StudioRoute: StudioRoute,TermsRoute: TermsRoute,CheckoutReturnRoute: CheckoutReturnRoute,GuidesHoustonWebsiteCostRoute: GuidesHoustonWebsiteCostRoute,GuidesSquarespaceVsCustomWebsiteRoute: GuidesSquarespaceVsCustomWebsiteRoute,GuidesWebsiteAuditChecklistRoute: GuidesWebsiteAuditChecklistRoute,PortalLoginRoute: PortalLoginRoute,ProposalTokenRoute: ProposalTokenRoute,RedesignTokenRoute: RedesignTokenRoute,SiteReportTokenRoute: SiteReportTokenRoute,StudioPrivacyRoute: StudioPrivacyRoute,StudioTermsRoute: StudioTermsRoute,WorkSlugRoute: WorkSlugRoute,RedesignIndexRoute: RedesignIndexRoute,WorkIndexRoute: WorkIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)